import { render } from "./CoinList.vue?vue&type=template&id=1b13f467"
import script from "./CoinList.vue?vue&type=script&lang=js"
export * from "./CoinList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__